<template>
	<div>
		<p>
			<em>Auch unsere AGB haben wir weitestgehend &bdquo;bullshitfrei&ldquo; gestaltet und auf überflüssige
			Inhalte oder eine ellenlange Ausformulierung verzichtet.</em>
		</p>

		<div v-html="termsHtml"></div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'terms',
	data () {
		return {
			termsHtml: 'AGB-Inhalte werden geladen...',
			apiToken: false
		}
	},
	methods: {
		async fetchApiToken () {
			const that = this

			if (this.apiToken) return this.apiToken

			await axios.post(process.env.VUE_APP_API_AUTH_BASE_URL + '/token', {}, {withCredentials: true})
				.then(function (response) {
					if (response.status === 200 && response.data.token) {
						that.apiToken = response.data.token
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + that.apiToken
					}
				})

			return that.apiToken
		}
	},
	mounted () {
		const that = this

		this.fetchApiToken().then(function() {
			axios.get(process.env.VUE_APP_API_BASE_URL + '/special-contents/terms', {})
				.then(function (response) {
					if (response.status === 200) {
						that.termsHtml = response.data.data.html
					}
				})
		})
	}
}
</script>